import { Component, OnInit, Input } from '@angular/core';
import { ResourceService } from '@services/index.service';
import { environment } from "@environments/environment";

@Component({
  selector: 'slot-information',
  templateUrl: './slot-information.component.html',
  styleUrls: ['./slot-information.component.scss']
})
export class SlotInformationComponent implements OnInit {

  @Input() disableNotificatoins: boolean = false;

  optionalFieldsForSlots = environment.OPTIONAL_FIELDS_FOR_SLOTS;

  constructor(public _resourceService: ResourceService) {

  }

  ngOnInit() {
  }

}
